import { Modal, IModal } from '../Modal';
import Button from '@mui/material/Button';
import { generatePath, useNavigate } from 'react-router';
import URLs from '../../../pages/URLs';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const ConfirmationModal = ({ open, handleClose }: IModal) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { salonId } = useParams();

  const buttons = () => (
    <>
      <Button variant="outlined" onClick={handleClose}>
        {t('confirmationModal.stay')}
      </Button>
      <Button variant="contained" onClick={() => navigate(generatePath(URLs.Salon, { salonId }))}>
        {t('confirmationModal.leave')}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      header={t('confirmationModal.header')}
      mainContent={t('confirmationModal.mainContent')}
      isSaveButton
      buttons={buttons()}
      handleClose={handleClose}
    />
  );
};
